import { NftSellOfferMoleculeReatom } from "@/app/collections/instant-sell/use-collection-nfts-sell.reatom"
import { CheckMarkIcon } from "@/app/icons/check-mark"
import { PlusIcon } from "@/app/icons/plus"
import type { NftId, NftMiniature } from "@anaconda/core/nft/types"
import { Slot, cn } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { useCallback } from "react"
import { NftSelectionMoleculeReatom } from "./nft-selection-molecule.reatom"

interface Props {
  nft: NftMiniature
  children: React.ReactNode
  className?: string
}

export const NFTSelectionToggle = reatomComponent<Props>(
  ({ nft, className, ...props }) => {
    const { toggleNft, hasOfferToMatch } = useMolecule(
      NftSellOfferMoleculeReatom,
    )

    const isSelectable = hasOfferToMatch()

    const onClick = useCallback(() => {
      toggleNft(nft)
    }, [toggleNft, nft])

    return (
      <Slot
        {...props}
        onClick={onClick}
        style={{
          cursor: isSelectable ? "pointer" : "default",
        }}
      />
    )
  },
  "NFTSelectionToggle",
)

interface SelectionToggleStatusProps {
  nftId: NftId
}

export const SelectionToggleStatus =
  reatomComponent<SelectionToggleStatusProps>(
    ({ nftId }: SelectionToggleStatusProps) => {
      const { selectedNftsAtom } = useMolecule(NftSelectionMoleculeReatom)
      const selectedNfts = selectedNftsAtom()
      const selected = selectedNfts.some((nft) => nft.id === nftId)

      return (
        <div
          className={cn(
            "flex h-6 w-6 items-center justify-center rounded-full border p-0",
            selected
              ? "border-transparent bg-brand text-muted"
              : "border-white/10 bg-transparent",
          )}
        >
          {selected ? <CheckMarkIcon /> : <PlusIcon />}
        </div>
      )
    },
    "SelectionToggleStatus",
  )
